import EmscriptenFactory from './vectorize-emscripten.js'
let gWasmPromise = EmscriptenFactory({});

export async function vectorizeAsync(imageData, imgName, graphicType, wantConvertToPNG=false) {
    const Emscripten = await gWasmPromise;
    const kIncludeColorBitmapWithoutBG = false;

    const isColor = (graphicType === "color");

    var uint8bytes = new Uint8Array(imageData);
    Emscripten.FS.writeFile(imgName, uint8bytes);

    var svgBase = "out";
    var args = [imgName, svgBase + ".svg"];
    if (isColor && kIncludeColorBitmapWithoutBG) {
        args = ["--write-png-without-background"].concat(args);
    }
    if (wantConvertToPNG) {
        args = ["--convert-to-png"].concat(args);
    }
    Emscripten.callMain(args);

    var output = [
        { name: "Auto",
          svg: Emscripten.FS.readFile(svgBase + ".svg"),
          dxf: Emscripten.FS.readFile(svgBase + ".dxf") },
        { name: "Auto, inverted",
          svg: Emscripten.FS.readFile(svgBase + "_inverted.svg"),
          dxf: Emscripten.FS.readFile(svgBase + "_inverted.dxf") },
    ];
    
    var optional = [ { suffix: "_threshold3", name: "Threshold (30%)" },
                     { suffix: "_threshold5", name: "Threshold (50%)" },
                     { suffix: "_threshold7", name: "Threshold (70%)" },
                     { suffix: "_anycolor",   name: "All colors black" } ];
    for (const opt of optional) {
        try {
            const stat = Emscripten.FS.stat(svgBase + opt.suffix + ".svg");
            if (stat != null) {
                output.push({
                    name: opt.name,
                    svg: Emscripten.FS.readFile(svgBase + opt.suffix + ".svg"),
                    dxf: Emscripten.FS.readFile(svgBase + opt.suffix + ".dxf"),
                });
            }
        } catch(e) {}
    }

    if (isColor) {
        output.push({
            name: "Color",
            svg: null,
            dxf: null,
            bitmap: uint8bytes
        });
        if (kIncludeColorBitmapWithoutBG) {
            try {
                const stat = Emscripten.FS.stat(svgBase + "_nobg.png");
                if (stat != null) {
                    output.push({
                        name: "Color, background removed",
                        svg: null,
                        dxf: null,
                        bitmap: Emscripten.FS.readFile(svgBase + "_nobg.png"),
                    });
                }
            } catch(e) {}
        }
    }

    if (wantConvertToPNG) {
        try {
            const path = svgBase + "_converted.png";
            const stat = Emscripten.FS.stat(path);
            if (stat != null) {
                output.push({
                    name: "Converted to PNG",
                    svg: null,
                    dxf: null,
                    bitmap: Emscripten.FS.readFile(path),
                });
            }
        } catch(e) {}
    }

    return output;
}

export async function vectorizeBasicTransparentAsync(imageData, imgName) {
    const Emscripten = await gWasmPromise;
    var uint8bytes = new Uint8Array(imageData);
    Emscripten.FS.writeFile(imgName, uint8bytes);

    var svgBase = "out";
    Emscripten.callMain(["--basic-transparent", imgName, svgBase + ".svg"]);

    return { name: "Auto",
             svg: Emscripten.FS.readFile(svgBase + ".svg"),
             dxf: Emscripten.FS.readFile(svgBase + ".dxf") };
}
